import "./App.css";
import Layout from "./components/ui/layout";
import Main from "./components/Main/Main";

function App() {
  return (
    <Layout>
      <Main />
    </Layout>
  );
}

export default App;
